import { useContext } from 'react';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { useConcurrencyServiceWithFetch } from './../../../hooks/useConcurrencyService';
import url from '../../../helpers/url';
import h from '../../../helpers/common';
import { updateYouboraAnalytics } from '../../../helpers/youbora';
import { playerTypes } from '@libs/constants';
import { EVENT } from '../../../contexts/MixpanelConstants';

interface SimpleEpisode {
    Id: string;
    guid: string;
    tvSeasonNumber: number;
    streamingUrl: string;
}

export const useEpisodeActions = () => {
    const { track } = useContext(MixpanelContext);
    const { unLock } = useConcurrencyServiceWithFetch();

    /**
     * Executes the core side-effects (analytics, locking, navigation) needed to switch episodes.
     */
    const navigateToEpisode = async (episode: SimpleEpisode, source = 'Play Button') => {
        updateYouboraAnalytics(episode, episode.streamingUrl, playerTypes.Vod);
        track(h.getScreen() + ' - ' + EVENT.VOD_PLAYER.NEXT_EPISODE_VIEW, {});
        track(h.getScreen() + ' - ' + EVENT.VOD_PLAYER.NEXT_EPISODE_START_PLAY, {
            Source: 'Play Button',
        });

        const lockId = sessionStorage.getItem('lockId');
        if (lockId) {
            await unLock(lockId);
            sessionStorage.removeItem('lockId');
        }

        window.location.replace(
            url.route('play', {
                id: btoa(episode.Id),
                guid: btoa(episode.guid),
                season: episode.tvSeasonNumber,
            })
        );
    };

    return { navigateToEpisode };
};
